import { Component, OnInit } from '@angular/core';
import { HeaderNsideService } from '../../services/HeaderNside.service';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-sa-logs',
  templateUrl: './sa-logs.component.html',
  styleUrls: ['./sa-logs.component.css']
})
export class SaLogsComponent implements OnInit {
  logsList: any[];
  showOverlay: boolean;
  searchTermLog: string = '';
  pageNo: number;
  showOverlaySmall: boolean;
  logsCount: number = 0;
  logError = new ErrorModel();
  constructor(private _service: HeaderNsideService) { }

  ngOnInit() {
    this.logsCount = 0;
    this.pageNo = 1;
    this.getSaLogs(1);
  }

  getSaLogs(value) {
    this.showOverlay = true;
    this.showOverlaySmall = true;
    const pageIs = value == 1 ? this.pageNo : 1;
    this.logError.display = false;
    this._service.getSaLogs(pageIs, this.searchTermLog).subscribe(
    (data: any[]) => {
      this.setData(data, true);
    },
    (error) => {
      this.logError.error = error;
      this.logError.display = true;
    }).add(() => {
      this.showOverlay = false;
      this.showOverlaySmall = false;
    });
  }

  //----------------------------------
  setData(data,type) {
    this.logsList = data['ActionHistoryList'];
    if (type) { this.logsCount = data['LogsCount']; }
    this.logsList.forEach(i => {
      let logT = new Date(i.logTime);
      i.LogTime = logT.getHours() + ':' + logT.getMinutes();
    })
    this.showOverlay = false;
    this.showOverlaySmall = false;

  }

  onScrollGetActionHistories() {
    this.showOverlaySmall = true;
    this.pageNo = this.pageNo + 1;
    this._service.getSaLogs(this.pageNo, this.searchTermLog).subscribe(
    (data: any[]) => {
      const loglist = data['ActionHistoryList'];
      loglist.forEach(i => {
        let logT = new Date(i.logTime);
        i.LogTime = logT.getHours() + ':' + logT.getMinutes();
        this.logsList.push(i);
      });
    },
    (error) => {
      this.pageNo = this.pageNo - 1;
    }).add(() => {
      this.showOverlaySmall = false;

    });
  }
}
